<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6668 2.33337H10.8502L7.00016 6.18337L3.15016 2.33337H2.3335V3.15004L6.1835 7.00004L2.3335 10.85V11.6667H3.15016L7.00016 7.81671L10.8502 11.6667H11.6668V10.85L7.81683 7.00004L11.6668 3.15004V2.33337Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
</template>
